export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64')
];

export const server_loads = [2,5];

export const dictionary = {
		"/(private)": [6,[2]],
		"/auth": [23,[4]],
		"/auth/forgot-password": [24,[4]],
		"/auth/reset-password/[token]": [25,[4]],
		"/auth/set-password/[id]/[token]": [26,[4]],
		"/(private)/brands": [~7,[2]],
		"/(private)/brands/[id]": [~8,[2]],
		"/cookie-auth": [~27],
		"/(private)/domain-takedowns": [~9,[2]],
		"/(private)/external-links": [~10,[2]],
		"/(private)/listings/details": [~14,[2]],
		"/(private)/listings/[status]": [~11,[2]],
		"/(private)/listings/[status]/[id]": [~12,[2]],
		"/(private)/listings/[status]/[id]/details": [~13,[2]],
		"/(public)/login": [~21,[3]],
		"/(private)/marketplaces": [~15,[2]],
		"/(private)/providers": [~16,[2]],
		"/(private)/providers/[id]": [~17,[2]],
		"/(public)/reset": [~22],
		"/uilib/brands/brands-details": [~28,[5]],
		"/uilib/brands/brands-details/[slug]/[id]": [~29,[5]],
		"/uilib/brands/brands-sellers/[id]": [~30,[5]],
		"/uilib/brands/brands-userlist": [31,[5]],
		"/uilib/brands/brands-view": [~32,[5]],
		"/uilib/brands/marketplace-details/[brandid]/[marketplaceid]": [~34,[5]],
		"/uilib/brands/marketplace/[id]": [33,[5]],
		"/uilib/categories": [35,[5]],
		"/uilib/categories/create-parent": [38,[5]],
		"/uilib/categories/edit-child/[id]": [39,[5]],
		"/uilib/categories/edit-parent/[id]": [40,[5]],
		"/uilib/categories/order": [41,[5]],
		"/uilib/categories/[id]": [36,[5]],
		"/uilib/categories/[id]/create-child": [37,[5]],
		"/uilib/domains": [42,[5]],
		"/uilib/domains/details/[slug]/[id]": [~43,[5]],
		"/uilib/licensors": [44,[5]],
		"/uilib/licensors/licensor-details": [46,[5]],
		"/uilib/licensors/licensor-details/[slug]/[id]": [~47,[5]],
		"/uilib/licensors/licensors-view": [48,[5]],
		"/uilib/licensors/[slug]": [~45,[5]],
		"/uilib/listings-scanner": [51,[5]],
		"/uilib/listings": [49,[5]],
		"/uilib/listings/details/[slug]": [~50,[5]],
		"/uilib/marketplaces": [52,[5]],
		"/uilib/overview": [53,[5]],
		"/uilib/sdc-settings": [54,[5]],
		"/uilib/sellers/list": [55,[5]],
		"/uilib/sellers/seller-brand": [56,[5]],
		"/uilib/sellers/seller-create": [57,[5]],
		"/uilib/sellers/seller-details/[slug]/[id]": [~58,[5]],
		"/uilib/sellers/seller-new": [~59,[5]],
		"/uilib/sellers/website-seller-detail/[slug]/[id]": [~61,[5]],
		"/uilib/sellers/website-seller": [~60,[5]],
		"/uilib/users": [62,[5]],
		"/uilib/users/create": [64,[5]],
		"/uilib/users/[user_id]": [63,[5]],
		"/(private)/users-invite": [~20,[2]],
		"/(private)/users": [~18,[2]],
		"/(private)/users/[id]": [~19,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';